import { AutopiloteVsl } from '@/components/vsl/AutopiloteVsl';

// Envoyée aux prospects qui ont déjà pris rendez-vous
export default function AutopilotePage() {
  return <AutopiloteVsl variant="booked" />;
}
